module.exports = __webpack_public_path__ + "img/Ukraine.3b83bfd4.png";